import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import App from './App';
import { SITE_BASE } from './siteConfig';

const Root = () => (
  <Router basename={SITE_BASE || undefined}>
    <Routes>
      <Route path="*" element={<App />} />
    </Routes>
  </Router>
);

export default Root;